import { Box } from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { FormTitleBox, TableBodySkeleton } from '../../common/components';
import InternalOrdersDataTable from './components/InternalOrdersDataTable';
import InternalOrdersFilters from './components/InternalOrdersFilters';
import InternalOrdersPagination from './components/InternalOrdersPagination';
import InternalOrderDialog from './components/InternalOrderDialog';
import InternalOrderDetailDialog from './components/InternalOrderDetailDialog';
import { useInternalOrdersTable } from './hooks/useInternalOrdersTable';
import { usePermissions } from '../../hooks/usePermissions';

const InternalOrdersTable = () => {
  const { permissions } = usePermissions();
  const {
    data,
    isLoading,
    isSaving,
    isProcessing,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    searchTerm,
    filters,
    dialogOpen,
    detailDialogOpen,
    selectedOrder,
    selectedOrderDetail,
    detailOrderLoading,
    warehouses,
    projects,
    projectsLoading,
    warehousesLoading,
    handleSearch,
    handleFilterChange,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
    handleSelectChange,
    handleAddMaterial,
    handleUpdateMaterialQuantity,
    handleRemoveMaterial,
    handleSave,
    handleViewDetail,
    handleCloseDetailDialog,
    handleAuthorizeOrder,
    handleCheckStock,
    handleSetConsumptionAuthorization,
    handleRefreshDetailOrder,
  } = useInternalOrdersTable();

  return (
    <Box>
      <FormTitleBox
        title="Stock y Compras | Pedidos técnicos"
        showButton={permissions.canCreateInternalOrders}
        buttonText="Nuevo pedido"
        buttonIcon={AddShoppingCartIcon}
        onButtonClick={handleOpenDialog}
        showSearch={true}
        searchLabel="Buscar pedido"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
        isLoading={isSaving || isProcessing}
      />

      <InternalOrdersFilters
        filters={filters}
        warehouses={warehouses}
        projects={projects}
        onFilterChange={handleFilterChange}
        onSelectChange={handleFilterChange}
      />

      <InternalOrdersDataTable
        data={data}
        isLoading={isLoading}
        actionsDisabled={isSaving || isProcessing}
        onView={handleViewDetail}
        LoadingComponent={TableBodySkeleton}
      />

      {totalPages > 1 && (
        <InternalOrdersPagination
          totalPages={totalPages}
          totalCount={totalCount}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )}

      <InternalOrderDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        selectedOrder={selectedOrder}
        onInputChange={handleInputChange}
        onSelectChange={handleSelectChange}
        onSave={handleSave}
        warehouses={warehouses}
        warehousesLoading={warehousesLoading}
        projects={projects}
        projectsLoading={projectsLoading}
        searchEnabled={dialogOpen}
        onAddMaterial={handleAddMaterial}
        onUpdateMaterialQuantity={handleUpdateMaterialQuantity}
        onRemoveMaterial={handleRemoveMaterial}
        isSaving={isSaving}
      />

      <InternalOrderDetailDialog
        open={detailDialogOpen}
        onClose={handleCloseDetailDialog}
        order={selectedOrderDetail}
        onAuthorizeOrder={handleAuthorizeOrder}
        onCheckStock={handleCheckStock}
        onSetConsumptionAuthorization={handleSetConsumptionAuthorization}
        onOrderUpdated={handleRefreshDetailOrder}
        isProcessing={isProcessing}
        isLoading={detailOrderLoading}
      />
    </Box>
  );
};

export default InternalOrdersTable;
